<div class="min-h-screen flex flex-col">
  <p-toast></p-toast>
  <div *ngIf="loading" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <main class="flex-1 max-w-4xl mx-4 p-4">
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  </main>
</div>
